import { SideNav } from '@neo.tax/shared';

import { useRdNavSections } from './hooks';

export const RdSideNav = (): React.ReactElement => {
  const sections = useRdNavSections();
  return <SideNav sections={sections} variant="dark" gap={4} />;
};
